export default __webpack_public_path__ + "static/media/defaultPrizeDrawImage.43a9bdf6.png";